export default [
  {
    title: '特徴1：ほげほげほげほげ',
    img: 'https://via.placeholder.com/375x200',
    description: 'hogehogehogehogehogehogehogehogehogehogehogehogehogehogehogehogehogehogehogehogehogehogehogehoge',
  },
  {
    title: '特徴2：ほげほげほげほげ',
    img: 'https://via.placeholder.com/375x200',
    description: 'hogehogehogehogehogehogehogehogehogehogehogehogehogehogehogehogehogehogehogehogehogehogehogehoge',
  },
  {
    title: '特徴3：ほげほげほげほげ',
    img: 'https://via.placeholder.com/375x200',
    description: 'hogehogehogehogehogehogehogehogehogehogehogehogehogehogehogehogehogehogehogehogehogehogehogehoge',
  },
]
